var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tbody",
    {
      staticClass: "plant-group",
      class: { even: _vm.index % 2 === 0, odd: _vm.index % 2 !== 0 }
    },
    _vm._l(_vm.productGroup.available_products, function(product, i) {
      return _c("order-table-item-component", {
        key: product.ProductID,
        attrs: { index: i, product: product, plantDetails: _vm.plantDetails }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }